import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PyramidServices from './components/PyramidServices';
import AnimatedGallery from './components/AnimatedGallery';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';
import CookieBanner from './components/CookieBanner';

const HomePage = () => (
  <div className="bg-[#08080c] min-h-screen">
    <Navbar />
    <HeroSection />
    <PyramidServices />
    <AnimatedGallery />
    <AboutSection />
    <ContactSection />
    <FooterSection />
    <CookieBanner />
  </div>
);

export default HomePage;
